import $ from 'jquery'

$(document).ready(function () {
  let winHeight = $(window).height(),
    docHeight = $(document).height(),
    progressBar = $('.reader-progress'),
    max,
    value

  max = docHeight - winHeight

  $(document).on('scroll', function () {
    value = $(window).scrollTop()
    progressBar.css('height', (value / max) * 100 + '%')
  })

  $(window).on('resize', function () {
    winHeight = $(window).height()
    docHeight = $(document).height()

    max = docHeight - winHeight
    progressBar.css('height', (value / max) * 100 + '%')
  })
})
